// ============================================
// ملف: src/components/Services.js
// ============================================
import React from 'react';
 
const translations = {
  ar: {
    title: "الخدمات والحلول التخصصية",
    sub: "نحول عبء النفايات إلى فرص استثمارية",
    cards: [
      { icon: "fas fa-tower-broadcast", title: "تفكيك وإزالة بنية الاتصالات التحتية", desc: "تفكيك احترافي وشامل لأبراج الاتصالات، وكبائن الأجهزة، والهوائيات، وحتى صحون الميكروويف مع استعادة كاملة للمواد الأولية" },
      { icon: "fas fa-microchip", title: "استعادة الأصول للأجهزة الإلكترونية والطبية", desc: "معالجة عالية الدقة تشمل الفحص، الترميز، والتدمير الآمن للبيانات، تتبعها عمليات التحميل والنقل بنظام متكامل لمنشأتنا؛ لفك وفرز المواد والأجهزة المهملة وتحويلها لمواد أولية لها قيمة دائرية في اقتصادنا الوطني" },
      { icon: "fas fa-industry", title: "إدارة المواد ذات المعالجة الخاصة", desc:"تعامل مهني مع وحدات الطاقة، والبطاريات الصناعية، والزيوت، وغازات التبريد وفق بروتوكولات سلامة صارمة"  }
    ]
  },
  en: {
    title: "Core Services",
    sub: "Transforming Waste Burdens into Investment Opportunities",
    cards: [
      { icon: "fas fa-tower-broadcast", title: "Telecom Infrastructure Dismantling & Removal", desc: "Processing phones, computers, screens, and batteries. Extracting gold, silver, copper, and aluminum with 99% purity, plus secure data destruction" },
      { icon: "fas fa-microchip", title: "E-Waste & Medical Asset Recovery", desc: "High-precision processing including inspection, coding, and secure data destruction, followed by integrated loading and transport systems to our facility for dismantling and sorting discarded equipment into circular-value raw materials" },
      { icon: "fas fa-industry", title: "Specialized Material Management", desc: "Professional handling of power units, industrial batteries, oils, and refrigerant gases according to strict safety protocols" }
    ]
  }
};

const Services = ({ currentLang }) => {
  const t = translations[currentLang];

  return (
    <section id="services" className="services-section">
      <div className="services-overlay"></div>
      <div className="services-content">
        <h2 className="section-title">{t.title}</h2>
        <p className="section-sub">{t.sub}</p>
        <div className="cards-container">
          {t.cards.map((card, index) => (
            <div className="card" key={index}>
              <div className="card-icon"><i className={card.icon}></i></div>
              <h3>{card.title}</h3>
              <p>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .services-section {
          position: relative;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-attachment: fixed;
          overflow: hidden;
        }
        
        .services-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
        
        .services-content {
          position: relative;
          z-index: 2;
        }
        
        .cards-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 2rem;
        }
        
        .card {
          background: rgba(255, 255, 255, 0.92);
          backdrop-filter: blur(10px);
          border-radius: 32px;
          padding: 2rem;
          width: 350px;
          transition: all 0.4s ease;
          text-align: center;
          border: 1px solid rgba(83, 176, 150, 0.25);
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
        }
        
        .card:hover {
          transform: translateY(-10px);
          border-color: #53b096;
          background: rgba(255, 255, 255, 0.98);
          box-shadow: 0 20px 40px rgba(83, 176, 150, 0.15);
        }
        
        .card-icon {
          font-size: 3.5rem;
          margin-bottom: 1rem;
          color: #53b096;
        }
        
        .card h3 {
          color: #1a2a3a;
          margin-bottom: 0.8rem;
          font-size: 1.5rem;
        }
        
        .card p {
          color: #5a6a7a;
          line-height: 1.7;
        }
        
        /* تنسيق عنوان القسم مع الخلفية */
        .services-section .section-title {
          color: #1a2a3a;
        }
        
        .services-section .section-title:after {
          background: linear-gradient(90deg, #53b096, #71b887, #53b096);
        }
        
        .services-section .section-sub {
          color: #4a5a6a;
        }
        
        @media (max-width: 768px) {
          .card { width: 100%; max-width: 350px; }
          .services-section {
            background-attachment: scroll;
          }
        }
        
        /* دعم المتصفحات لـ background-attachment: fixed */
        @supports (background-attachment: fixed) {
          .services-section {
            background-attachment: fixed;
          }
        }
      `}</style>
    </section>
  );
};

export default Services;